import React, {useEffect, useState} from "react"
import { HashRouter, Route, Switch, useRouteMatch, BrowserRouter } from "react-router-dom";
import logo from './logo.svg';
import './styles/globals.scss';
import "./styles/flex.scss"
import Header from 'components/header/header';
import Accueil from "pages/accueil/accueil";
import ParcoursFormation from "pages/parcoursFormation/parcoursFormation";
import CrumbContext from "contexts/crumbs"
import HeadbandContext from "contexts/headband"
import HeadbandTitle from "components/headband/headbandTitle";
import routes from "components/routes/routes";
import RouteWithSubRoutes from "components/routes/routeWithSubRoutes";
import GuidePratique from "pages/parcoursFormation/guidePratique/guidePratique";
import BottomButton from "components/buttons/bottomButton";
import Formation from "pages/parcoursFormation/formations/formations";
import InscriptionFormation from "pages/parcoursFormation/incriptionFormation/inscriptionFormation";
import TrombiFormation from "pages/parcoursFormation/trombiFormation/trombiFormation";
import Drhf from "pages/drhf/drhf";
import TrombiDrhf from "pages/drhf/trombiDrhf/trombiDrhf";
import ActusIntranet from "pages/drhf/actuIntranet/actusIntranet";
import FicheContact from "pages/drhf/ficheContact/ficheContact";
import Reconversion from "pages/drhf/ficheContact/reconversion";
import CapsuleAnfh from "pages/drhf/capsuleAnfh/capsuleAnfh";
import ParcoursEvolution from "pages/parcoursEvolution/parcoursEvolution";
import TrombiParcoursPro from "pages/parcoursEvolution/trombiParcoursPro/trombiParcoursPro";
import DispositifsIndividuels from "pages/parcoursEvolution/dispositifsIndividuels/dispositifsIndividuels";
import BilanCompetence from "pages/parcoursEvolution/bilanCompetence/bilanCompetence";
import Cpf from "pages/parcoursEvolution/cpf/cpf";
import Vae from "pages/parcoursEvolution/vae/vae";
import EtudesPromotionnelles from "pages/parcoursEvolution/etudesPromotionnelles/etudesPromotionnelles";
import Cfp from "pages/parcoursEvolution/cfp/cfp";
import Avis from "pages/avis/avis";
import BoiteIdee from "pages/avis/boiteIdee/boiteIdee";
import Site from "pages/site/site";
import ListeFormation from "pages/parcoursFormation/formations/listeFormation/listeFormation";
import Actus from "pages/parcoursFormation/formations/actus/actus";
import Confidentialite from "pages/confidentialite/confidentialite";
export default function App() {
	const [counter, setCounter] = useState(5)
	const [opacity, setOpacity] = useState(1)
	// const { url, path } = useRouteMatch();
	const [crumbs, setCrumbs] = useState([
		{
			title : "Accueil",
			page : "/accueil",
			color :"",
			icon : ""
		}
	]);
	const [headband, setHeadband] = useState({
		title : "",
		icon : "",
		color : ""
	});
	const counterDefault = 120
	useEffect(() => {
		const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
		if(timer <= 0 && crumbs.length !== 1) document.location.href="/"
		return () => clearInterval(timer)
	}, [counter])
	const [items, setItems] = useState([])
    const loadImage = () => {
        for(let i = 1; i < 63; i++){
            setItems(oldArray => [...oldArray, <img key={i} src={`carousel/(${i}).jpg`} alt={i}/>])
        }
    }
    useEffect(() => {
        loadImage()
    }, [])
	useEffect(() => {
		setCounter(counterDefault)
	}, [crumbs])
	return (
		<div id='Layout' className="app">
			<BrowserRouter>
				<HeadbandContext.Provider value={{headband, setHeadband}}>
					<CrumbContext.Provider value={{crumbs, setCrumbs}}>
						<Header/>
						<div id="container">
							<Switch>
								<Route path="/" exact>
									<Accueil items={items}/>
								</Route>
								<Route path="/accueil" exact>
									<Accueil items={items}/>
								</Route>
								<Route path="/accueil/confidentialite" exact component={Confidentialite}/>
								<div className="w100 h100">
									<HeadbandTitle/>
									<Route path="/accueil/parcours_formation" exact component={ParcoursFormation}/>
									<>
										<Route path="/accueil/parcours_formation/guide_pratique" exact>
											<GuidePratique setCounter={setCounter} counterDefault={counterDefault}/>
										</Route>
										<Route path="/accueil/parcours_formation/formations" exact>
											<Formation setCounter={setCounter} counterDefault={counterDefault}/>
										</Route>
										<>
											<Route path="/accueil/parcours_formation/formations/liste_formation" exact>
												<ListeFormation setCounter={setCounter} counterDefault={counterDefault}/>
											</Route>
											<Route path="/accueil/parcours_formations/formations/actus" exact component={Actus}/>									
										</>
										<Route path="/accueil/parcours_formation/inscription_formation" exact>
											<InscriptionFormation setCounter={setCounter} counterDefault={counterDefault}/>
										</Route>
										<Route path="/accueil/parcours_formation/trombinoscope_formation" exact component={TrombiFormation}/>
									
									</>
									<Route path="/accueil/drhf" exact component={Drhf}/>
									<>
										<Route path="/accueil/drhf/trombi_drhf" exact component={TrombiDrhf}/>
										<Route path="/accueil/drhf/actus_intranet" exact component={ActusIntranet}/>
										<Route path="/accueil/drhf/fiche_contact" exact component={FicheContact}/>
										<Route path="/accueil/drhf/fiche_contact/reconversion" exact component={Reconversion}/>
										<Route path="/accueil/drhf/capsule_anfh" exact>
											<CapsuleAnfh setCounter={setCounter} counterDefault={counterDefault}/>
										</Route>								
									</>
									<Route path="/accueil/parcours_evolution" exact component={ParcoursEvolution}/>
									<>
										<Route path="/accueil/parcours_evolution/trombinoscope_parcours_pro" exact component={TrombiParcoursPro}/>
										<Route path="/accueil/parcours_evolution/dispositifs_individuels" exact component={DispositifsIndividuels}/>
										<Route path="/accueil/parcours_evolution/cpf" exact component={Cpf}/>
										<Route path="/accueil/parcours_evolution/cfp" exact component={Cfp}/>
										<Route path="/accueil/parcours_evolution/vae" exact component={Vae}/>
										<Route path="/accueil/parcours_evolution/etudes_Promotionnelles" exact component={EtudesPromotionnelles}/>
										<Route path="/accueil/parcours_evolution/bilan_competence" exact component={BilanCompetence}/>									
									</>
									<Route path="/accueil/avis" exact component={Avis}/>
									<Route path="/accueil/avis/boite_idee" exact>
										<BoiteIdee setCounter={setCounter} counterDefault={counterDefault}/>
									</Route>
									<Route path="/accueil/site" exact component={Site}/>
									
									<BottomButton/>
								</div>		
							</Switch>
						</div>
					</CrumbContext.Provider>
				</HeadbandContext.Provider>
			</BrowserRouter>
		</div>
	);
}